import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';

import {
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { formatRoute } from 'react-router-named-routes';

import DashboardLayout from '../../dashboard/components/DashboardLayout';
import DisplayProfile from '../components/DisplayProfile';
import Alert from '../../common/components/Alert';
import * as profileActions from '../actions';
import * as routes from '../../config/routes';


class ViewProfile extends Component {
  componentDidMount() {
    document.title = 'Loading Profile...';
    this.props.getProfile(
      this.props.token,
      this.props.match.params.uuid,
    );
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.uuid !== nextProps.match.params.uuid) {
      this.props.onUnmount();
      const uuid = nextProps.match.params.uuid;  // eslint-disable-line
      this.props.getProfile(this.props.token, uuid);
    }
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  editProfileSection = (section) => {
    this.props.history.push(
      formatRoute(
        routes.EDIT_PROFILE,
        {
          section: section,  // eslint-disable-line
        },
      ),
    );
  }

  printProfile = () => {
    this.props.history.push(
      formatRoute(
        routes.PRINT_PROFILE,
        {
          uuid: this.props.match.params.uuid,
        },
      ),
    );
  }

  render() {
    let profile = null;

    if (this.props.profile) {
      document.title = `
        ${this.props.profile.basicinfo.first_name} ${this.props.profile.basicinfo.last_name}
        - ${this.props.profile.profile_id}
      `;
      profile = (
        <DisplayProfile
          profile={this.props.profile}
          user={this.props.user}
          editProfileSection={this.editProfileSection}
          printProfile={this.printProfile}
          history={this.props.history}
        />
      );
    }

    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="home"
        dashActiveLink="profile"
        user={this.props.user}
      >
        {loading}
        {errorAlert}
        {profile}
      </DashboardLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.profile.loading,
    error: state.profile.error,
    profile: state.profile.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProfile: (token, slug) => dispatch(profileActions.getProfile(token, slug)),
    onUnmount: () => dispatch(profileActions.onUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewProfile));



// WEBPACK FOOTER //
// ./src/profile/containers/ViewProfile.js